import PropTypes from 'prop-types'
import { Overline } from '../../Nodes/Typography'

const loader = (props) => {
    const text = props.text || "LOADING"
    return (
        <div className="loader">
            <svg className="loader" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="40" />
            </svg>
            <Overline>&nbsp;&nbsp;&nbsp;{text}...</Overline>
        </div>)
}

loader.propTypes = {
    text: PropTypes.string 
}

export default loader